import React from 'react';
import '../css/rodape.css'; // Importando o CSS para o rodapé

function Footer() {
    return (
        <footer className="footer">
            <div className="footer-content">
                <p>&copy; {new Date().getFullYear()} GAM. Todos os direitos reservados.</p>
                <p>
                    <a href="https://www.gam.com.br/termos-de-uso/" target='_blank' className="footer-link">Termos de Uso</a> |
                    <a href="https://www.gam.com.br/politica-de-privacidade/" target='_blank' className="footer-link">Política de Privacidade</a>
                </p>
            </div>
        </footer>
    );
}

export default Footer;
